<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Edit Reminder</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <GenericEdit v-if="generic" ref="loadGeneric" :urls="urls"></GenericEdit>
        <CustomEdit v-else></CustomEdit>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/Reminders/MenuList.vue";
    import lang from "@/views/modules/Reminders/language/en";
    import GenericEdit from "@/components/layout/shared/generic/EditView.vue";
    import CustomEdit from "@/views/modules/Reminders/EditView.vue";

    export default {
        name: "new-reminder",
        components: {
            breadcrumbs,
            GenericEdit,
            CustomEdit,
        },
        data() {
            return {
                generic: false,
                metaList: [
                    {
                        type: 'text',
                        name: 'parent_type',
                        label: lang.LBL_PARENT_TYPE,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'parent_id',
                        label: lang.LBL_PARENT_ID,
                        required: true
                    },
                    {
                        type: 'selectbox',
                        name: 'reminder_type',
                        label: lang.LBL_REMINDER_TYPE,
                        required: true,
                        items: [
                            {
                                value: 'Daily',
                                id: '1'
                            },
                            {
                                value: 'On Due Date',
                                id: '2'
                            },
                        ],
                    },
                    {
                        type: 'datetime',
                        name: 'reminder_date',
                        label: lang.LBL_REMINDER_DATE,
                        required: true
                    },
                    {
                        type: 'multiselectbox',
                        name: 'users',
                        label: lang.LBL_USERS,
                        required: true,
                        items: [],
                    },
                    {
                        type: 'textarea',
                        name: 'description',
                        label: lang.LBL_DESCRIPTION,
                        required: true
                    },
                ],

                urls: 'api/modules/reminders',

                routePath: {
                    path: 'reminders',
                    detail: false
                }
            }
        },
        mounted() {
            this.childMethod()
        },
        methods: {
            getUserList() {
                const self = this;
                window.currentAction = 'detail';
                let searches = {};
                return axios.post('api/modules/users/select').then(function (response) {
                    var usersList = response.data.items;
                    var newusersList = usersList.map(user => ({
                        value: `${user.first_name} ${user.last_name}`,
                        id: user.id
                    }));
                    return newusersList;
                })
            },
            async childMethod() {
                const self = this;
                if (this.generic == true) {
                    var newusersList = await self.getUserList();
                    const usersField = this.metaList.find(field => field.name === 'users');
                    if (usersField) {
                        usersField.items = newusersList;
                    }
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
            }
        },
    }
</script>